export const getInitialStoreId = (options) => {
  const stores = options?.stores
  const suggested = options?.suggestedStoreId
  if (!Array.isArray(stores) || suggested === null || suggested === undefined)
    return null
  return stores.some((store) => store.id === suggested) ? suggested : null
}

export const toStoreLabel = (store) => store?.name || store?.code

export const canJoin = ({ agreed, amountError, submitting, storeId }) =>
  !!agreed &&
  !amountError &&
  !submitting &&
  storeId !== null &&
  storeId !== undefined
